var ResponsiveObserver = null

if (typeof window !== 'undefined') {
    const module = require('responsive-observer')
    ResponsiveObserver = module.default
}

export default {
    data () {
        return {
            isDesktop: false,
            isMobile: false,
            isPad: false
        }
    },
    methods: {
        bindResponsiveObserver () {
            if (ResponsiveObserver) {
                this.observer = new ResponsiveObserver()
                this.observer.subscribe(screens => {
                    this.screens = screens
                    let isDesktop = screens.lg
                    let isMobile = !isDesktop && screens.xs
                    let isPad = !isDesktop && screens.sm
                    this.isDesktop = isDesktop
                    this.isMobile = isMobile
                    this.isPad = isPad
                })
            }
        },
        unbindResponsiveObserver () {
            if (this.observer) this.observer.unsubscribe()
        }
    },
    mounted () {
        this.bindResponsiveObserver()
    },
    beforeDestroy () {
        this.unbindResponsiveObserver()
    }
}



// WEBPACK FOOTER //
// ./src/components/framework/mixins/responsive-observer.js